/**
 * Fügt ein verlinktes und Animiertes Mouseicon hinzu
 *
 * Fügt ein Mouse Icon in den gewünschten Elementen hinzu und scrollt bei Klick an eine bestimmte Position.
 * Die Scroll-Position wird im Standard automatisch so ermittelt, dass der Container vom elementSelector nicht mehr
 * sichtbar ist. Dazu einfach scrollTop nicht übergeben.
 *
 * Event: document.ready
 *
 * @param elementSelector jquery Selector in den das Mouseicon eingebunden werden soll
 * @param scrollToPosition Festen Wert, oder nicht übergeben
 *
 * @return {undefined}
 */
function nc_initSliderMouseIcon(elementSelector, scrollToPosition) {
    var moduleLogger = LoggerManager.get('slider-mouse-icon').setPrefix('Selektor: ' + elementSelector);
    moduleLogger.trace('INIT START; scrollToPosition: ' + scrollToPosition);
    $(document).ready(function () {
        nc_sliderMouseIcon(elementSelector, scrollToPosition);
    });
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initSliderMouseIcon
 */
function nc_sliderMouseIcon(elementSelector, scrollToPosition) {
    var moduleLogger = LoggerManager.get('slider-mouse-icon').setPrefix('Selektor: ' + elementSelector);
    moduleLogger.trace('SCRIPT START; scrollToPosition: ' + scrollToPosition);
    // In den elementSelector wird das Mouseicon hinzugefügt. Bei Klick wird eine eine bestimmte Position gescrollt.
    moduleLogger.info('Tags hinzugefügt');
    $(elementSelector).append('<div class="mouse-icon"><div class="wheel"></div></div>');

    // Bei Klick, zur Position scrollen
    moduleLogger.info('Click Funktion registriert',$(elementSelector + ' .mouse-icon'));
    $(elementSelector + ' .mouse-icon').click(function () {
        var scrollTop = scrollToPosition;
        if (typeof scrollToPosition === 'undefined') {
            scrollTop = $(this).outerHeight(true) + $(this).offset().top;
        }
        $('html,body').animate({
            scrollTop: scrollTop
        }, 150);
        return false;
    });
    moduleLogger.info('SCRIPT ENDE');
}